__turbopack_context__.v({
  "left": "MiniDivider-module-scss-module__Z8kfyq__left",
  "miniDivider": "MiniDivider-module-scss-module__Z8kfyq__miniDivider",
  "right": "MiniDivider-module-scss-module__Z8kfyq__right",
});
